export const combineCN = (...classNames: Array<string | boolean | null | undefined>) => {
	return classNames?.filter(Boolean).join(' ') || '';
};
